import React from "react"
import { phoneNumber } from "../../utils/defaultMeta"
import { CallIcon } from "../icons"
import styles from "./contact.module.css"

export function Contact({ phone = phoneNumber }) {
  return (
    <div className={styles.contactContainer}>
      {/* <div className={styles.callNow}>
        <span style={{minWidth:'75px'}}>Call Now: </span>
      </div> */}
      <a href={`tel:+${phone}`} className={styles.contactButton}>
        <CallIcon color="#fff" />
      </a>
    </div>
  )
}
